export const ArrayOFSearchableFormFields = [{
  key: 'community.lookupItemName',
  title: 'Community',
 }, {
 key: 'sub_community.lookupItemName',
 title: 'Sub Community'
    }];
